export default __webpack_public_path__ + "static/media/novak.7a9ef4c4.jpg";